<main>
  <div class="container d-flex flex-column justify-content-center align-items-center">
    <div class="container-formulario d-flex flex-column justify-content-center align-items-center">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <img class="" src="../../assets/logo-removebg-preview.png" />
        <h2>Redefinir a senha</h2>
      </div>
      <div class="formulario d-flex flex-column justify-content-center align-items-center">
        <form [formGroup]="form" (ngSubmit)="submit()">
          <label>
            <input class="form-control" formControlName="vc_senha" type="password" name="password" id="password"
              placeholder="Nova senha">
          </label>
          <label>
            <input class="form-control" formControlName="vc_senha_confirmation" type="password" name="password"
              placeholder="Confirmar nova senha" />
          </label>
          <ul>
            <li id="minimo-caracteres" [class.tachado]="!senhasTemErro('minimocaracteres')">Deve conter pelo menos 6
              caracteres </li>
            <li id="sem-numeros" [class.tachado]="!senhasTemErro('naotemnumeros')">Deve conter números</li>
            <li id="sem-letras" [class.tachado]="!senhasTemErro('naotemletras')">Deve conter letras</li>
            <li id="sem-simbolos" [class.tachado]="!senhasTemErro('naotemsimbolos')">Deve conter caracteres especiais
            </li>
          </ul>
          <span *ngIf="!senhasCoincidem()" class="text-danger">As senhas não coincidem.</span>
          <div class="d-flex justify-content-center">
            <re-captcha (resolved)="validarRecaptcha($event)" (error)="validarRecaptcha()" errorMode="handled"
              id="recaptcha" name="recaptcha"></re-captcha>
          </div>
          <button class="btn-sucesso" [disabled]="form.invalid">
            Enviar
          </button>
        </form>
      </div>
    </div>
  </div>
</main>